<template>
  <main>
    <section class="hero hero--top" style="background-image:url(/images/home_bg.jpg)">
      <div class="hero__layer"></div>

      <div class="hero__top hero__top--home">
        <div class="container">
          <div class="hero__top__inner hero__top__inner--center">
            <div class="hero__top__block hero__top__block--home">
              <h1 class="hero__top__title">Σχετικά με το εργαλείο</h1>
            </div>
            <div class="hero__top__block hero__top__block--home">
              <img src="/images/top-icon.svg" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="article">
      <div class="container container--sm">
        <div class="article__content">
          <p>Το Vouliwatch, έχεις ως καταστατικό σκοπό την ενίσχυση της διαφάνειας και της λογοδοσίας στην πολιτική ζωή, την έγκυρη και ουσιαστική ενημέρωση των πολιτών και την προώθηση της δημοκρατικής συμμετοχής με τη βοήθεια της ψηφιακής τεχνολογίας. </p>
          <p>Στο πλαίσιο αυτό, ήταν ο πρώτος και μοναδικός -έως σήμερα- οργανισμός που ασχολήθηκε ενεργά και με εκστρατείες ενημέρωσης και άσκησης πολιτικής πίεσης για την αλλαγή στο νομικό πλαίσιο των Πόθεν Έσχες και των οικονομικών των κομμάτων και που έχει μεταγράψει και ψηφιοποιήσει τα πόθεν έσχες των Βουλευτών/τριών, όπως δημοσιεύονταν κάθε χρόνο από τη Βουλή, με καταγραφή στην παρούσα εφαρμογή των στοιχείων των Δηλώσεων που υποβάλλονταν από τους/τις υπόχρεους/-ες, παρουσιάζοντάς τα με απλό και εύληπτο τρόπο.</p>
          <p>Με το νέο μας, εξελιγμένο εργαλείο Πόθεν Έσχες, πηγαίνουμε τη διαφάνεια και τη λογοδοσία στο πολιτικό χρήμα ένα βήμα παραπέρα.
            Τώρα μπορείτε να δείτε συγκεντρωμένα και να συγκρίνετε τα πόθεν έσχες των Βουλευτών/-ριών μας από το από το 2012 έως και το 2018 με όλους τους πιθανούς τρόπους.</p>
          <p>Περιηγηθείτε στην εφαρμογή και:
          <ul>
            <li>Συγκρίνετε όλα τα περιουσιακά στοιχεία και τις μεταβολές τους, ανά χρονιά και ανά κατηγορία (είδος περιουσίας, εισοδήματα, ακίνητη κ.ο.κ.) για τον/την ίδιο/-α Βουλευτή/-ρια.</li>
            <li>Συγκρίνετε την περιουσιακή κατάσταση μεταξύ δύο διαφορετικών Βουλευτών/-ριών, επίσης ανά έτος και είδος περιουσίας. </li>
            <li>Δείτε τα Top 10 των Βουλευτών/-ριών ανά εισόδημα, ακίνητη περιουσία, τραπεζικές καταθέσεις ή/και δάνεια.</li>
            <li>Συγκρίνετε ανά κόμμα τον μέσο όρο περιουσίας των μελών του: δείτε τους Μέσους Όρους των περιουσιακών στοιχείων όλων των μελών μιας Κοινοβουλευτικής Ομάδας (π.χ. Μέσο εισόδημα Βουλευτή ανά Κ.Ο., μέσος αριθμός ακινήτων, Μ.Ο. αξίας τραπεζικών καταθέσεων και Μ.Ο. αξίας δανείων ανά Κ.Ο.). </li>
          </ul>
          </p>
          <p>
            Σάς υποσχόμαστε ότι θα εντυπωσιαστείτε από τα ευρήματα που θα εντοπίσετε με αυτόν τον εύκολο και καθαρά οπτικοποιημένο τρόπο έρευνας και ενημέρωσης για τις δηλώσεις περιουσιακής κατάστασης των εκπροσώπων μας στη Βουλή.
          </p>
          <p>
            Η ουσιαστική διαφάνεια στο πολιτικό χρήμα, δεν προέρχεται από την αποσπασματική παρουσίαση των οικονομικών τους στοιχείων, αλλά μόνο μέσα από την κατανοητή επισκόπηση και σύγκριση της πορείας της περιουσίας ενός/μίας Βουλευτή/-ριας μέσα στα χρόνια που ασκεί εξουσία.
          </p>
          <p>
            Καλή περιήγηση και #keepvouliwatching!
          </p>
        </div>

        <div class="article__bottom">
          <router-link
              :to="{ path: '/'}"
              class="btn btn--noback btn--noback--dark">
              ΑΝΑΖΗΤΗΣΗ ΔΗΛΩΣΕΩΝ
            </router-link>
          <router-link
              :to="{ path: '/compare'}"
              class="btn btn--std">
              ΣΥΓΚΡΙΣΗ
            </router-link>
        </div>
      </div>
    </section>

  </main>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    }
  },
  mounted() {
    this.loading = false;
    this.$emit("updateLoader", this.loading);
  },
  watch: {
    $route: {
        immediate: true,
        handler(to, from) {
            document.title = 'Σχετικά με το εργαλέιο | πόθεν έσχες - vouliwatch';
        }
    },
  }
}
</script>
